(() => {
  const bannerSelector = '.image-responsive-wrapper, .image-banner, .slideshow, .video-banner, .split-screen-slideshow, .gt-hero';
  const textSelector = '.slideshow-slide__text, .image-banner__wrapper, .video-banner__wrapper, .raices-hero__content, .split-screen-slideshow__text-slide, .gt-hero-content';
  let observer;
  let frame;
  let spacedElements = [];

  const clearSpacing = () => {
    spacedElements.forEach(element => {
      element.classList.remove('header-content-clearance');
      element.style.removeProperty('--header-content-clearance');
      element.style.removeProperty('--header-original-padding');
    });
    spacedElements = [];
  };

  const update = () => {
    const header = document.querySelector('.shopify-section-header');
    const main = document.querySelector('#MainContent');
    if (!header || !main) return;
    // Floating widgets and empty sections do not count as opening content.
    const first = [...main.children].find(element => element.getBoundingClientRect().height > 1);
    const banner = first?.matches(bannerSelector) ? first : first?.querySelector(bannerSelector);
    const overlay = banner && banner.getBoundingClientRect().height > 1
      && Math.abs(banner.getBoundingClientRect().top - first.getBoundingClientRect().top) < 2;

    if (!overlay) {
      clearSpacing();
      header.classList.remove('header-overlay');
      header.style.removeProperty('--overlay-header-height');
      header.style.removeProperty('--overlay-header-offset');
      return;
    }

    const targets = [...banner.querySelectorAll(textSelector)].filter(element => !element.parentElement.closest(textSelector));
    if (targets.length !== spacedElements.length || targets.some((element, index) => element !== spacedElements[index])) {
      clearSpacing();
      targets.forEach(element => {
        element.style.setProperty('--header-original-padding', getComputedStyle(element).paddingTop);
        element.classList.add('header-content-clearance');
      });
      spacedElements = targets;
    }
    spacedElements.forEach(element => element.style.setProperty('--header-content-clearance', `${header.offsetHeight + 24}px`));
    header.style.setProperty('--overlay-header-height', `${header.offsetHeight}px`);
    header.classList.add('header-overlay');
    // Measure in normal flow even when the sticky header is pinned to the viewport.
    const previousPosition = header.style.position;
    header.style.position = 'relative';
    const previousOffset = parseFloat(header.style.getPropertyValue('--overlay-header-offset')) || 0;
    const offset = banner.getBoundingClientRect().top - header.getBoundingClientRect().top + previousOffset;
    header.style.setProperty('--overlay-header-offset', `${offset}px`);
    header.style.position = previousPosition;
  };

  const updateScroll = () => {
    document.querySelector('.shopify-section-header')?.classList.toggle('header-scrolled', window.scrollY > 8);
  };

  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(update);
  };
  const initialize = () => {
    observer?.disconnect();
    clearSpacing();
    observer = new ResizeObserver(schedule);
    document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-header, #MainContent, #MainContent > *').forEach(element => observer.observe(element));
    schedule();
    updateScroll();
  };
  window.addEventListener('resize', initialize);
  window.addEventListener('load', schedule);
  window.addEventListener('scroll', updateScroll, { passive: true });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', initialize);
  document.addEventListener('shopify:section:reorder', initialize);
  initialize();
})();
